import { createSlice } from '@reduxjs/toolkit';
import { CreditScoreHistoryEntry } from 'api/ReportsApi';
import { getCreditScoreHistory } from 'thunks';

export interface CreditScoreHistoryState {
  history: CreditScoreHistoryEntry[] | null;
  isLoading: boolean;
  isError: boolean;
}

const initialState: CreditScoreHistoryState = {
  history: null,
  isLoading: false,
  isError: false,
};

const creditScoreHistory = createSlice({
  name: 'creditScoreHistory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCreditScoreHistory.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getCreditScoreHistory.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isError = false;
        state.history = payload.history;
      })
      .addCase(getCreditScoreHistory.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export default creditScoreHistory.reducer;
